module.exports = __webpack_public_path__ + "static/img/OOdesign.b96a9f14.png";